import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import BottomNav from "@/components/BottomNav";
import { SignIn } from "@phosphor-icons/react";

/**
 * ClientShell wraps client pages with the top brand header + fixed bottom nav.
 * Guests get a "sign in" bar instead of the client bottom nav.
 */
const CLIENT_BOTTOM_PAD = { paddingBottom: "calc(100px + env(safe-area-inset-bottom))" };

function GuestBar() {
  const navigate = useNavigate();
  return (
    <div
      data-testid="guest-signin-bar"
      className="fixed bottom-0 inset-x-0 z-40 bg-zinc-900 text-white px-4 py-3 flex items-center justify-between gap-3"
      style={{ paddingBottom: "calc(0.75rem + env(safe-area-inset-bottom))" }}
    >
      <div className="text-sm">
        <span className="font-semibold">Browsing as guest.</span>{" "}
        <span className="text-white/70">Sign in to request quotes &amp; track orders.</span>
      </div>
      <button
        onClick={() => navigate("/")}
        data-testid="guest-bar-signin"
        className="shrink-0 inline-flex items-center gap-1.5 bg-[#FF5A1F] hover:bg-[#E04814] text-white px-4 py-2 text-sm font-medium transition-colors"
      >
        <SignIn size={16} weight="bold" /> Sign In
      </button>
    </div>
  );
}

export default function ClientShell({ children }) {
  const { user, isGuest } = useAuth();
  const isClient = user?.role === "client";
  const padded = isClient || isGuest;

  return (
    <>
      <Layout>
        <div style={padded ? CLIENT_BOTTOM_PAD : undefined}>{children}</div>
      </Layout>
      {isClient && <BottomNav />}
      {!user && isGuest && <GuestBar />}
    </>
  );
}
